<template>
  <section class="product-intro">
    <div class="container">
      <h2 class="section-title">{{ title }}</h2>
      <div class="intro-cards">
        <div v-for="(item, index) in productFeatures" :key="index" class="feature-card" :class="{'featured': item.featured}">
          <div class="card-icon">
            <i :class="item.icon"></i>
          </div>
          <h3 class="card-title">{{ item.title }}</h3>
          <p class="card-description">{{ item.description }}</p>
        </div>
      </div>
      
      <div class="intro-content">
        <div class="quote-container">
          <div class="quote-mark start">❝</div>
          <div class="description-grid">
            <div v-for="(paragraph, index) in formattedDescriptions" :key="'p-'+index" 
                class="description-item" :class="{'highlight': index % 2 === 0}">
              <p class="intro-paragraph">{{ paragraph }}</p>
            </div>
          </div>
          <div class="quote-mark end">❞</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProductIntro',
  data() {
    return {
      title: 'Product Introduction',
      productFeatures: [
        {
          icon: 'icon-enhance',
          title: 'Quality Enhancement',
          description: 'Using advanced AI technology to improve photo resolution and clarity, making blurry photos look brand new',
          featured: true
        },
        {
          icon: 'icon-color',
          title: 'Color Enhancement',
          description: 'Intelligently adjust photo color balance and saturation to make old photos more vibrant and lively',
        },
        {
          icon: 'icon-repair',
          title: 'Photo Restoration',
          description: 'Repair scratches, creases, and noise in photos, perfectly restoring original photo details',
        }
      ],
      productDescription: `With Photo enhancer's AI photo enhancer, you can easily restore your old photos and bring them back to life with stunning HD quality.
        
        Preserve your cherished memories and relive them in crystal-clear detail with AI upscale's AI photo enhancer - the best tool to improve the quality of your photos.
        
        Don't settle for less than perfect photos. Use Photo enhancer's AI photo enhancer to fix blurry or low-quality photos and transform them into stunning works of art.
        
        Whether it's a blurry selfie or an old family photo, AI upscale's AI photo enhancer can improve the quality and restore the details you thought were lost forever.
        
        Make your photos pop with Photo enhancer's AI photo enhancer! With just a few clicks, you can enhance the quality of your photos and make them look like they were taken by a professional.
        
        Introducing Photo enhancer - AI upscale, the AI Photo Enhancer that restores and enhances your pixelated, blurry, and damaged photos to better quality. With Photo enhancer - AI upscale, your cherished memories will no longer be blurred or low-quality.`
    }
  },
  computed: {
    formattedDescriptions() {
      // Split text into paragraphs and remove excess whitespace
      return this.productDescription
        .split('\n')
        .map(p => p.trim())
        .filter(p => p.length > 0);
    }
  }
}
</script>

<style scoped>
.product-intro {
  padding: 80px 0;
  background-color: #ffffff;
  background-image: radial-gradient(circle at 10% 90%, rgba(240, 244, 255, 0.6) 0%, rgba(255, 255, 255, 0) 40%);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  font-size: 36px;
  color: #1a1a2e;
  text-align: center;
  margin-bottom: 50px;
  position: relative;
  font-weight: 700;
}

.section-title:after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: linear-gradient(90deg, #4a6bff, #2541b2);
  border-radius: 3px;
}

.intro-cards {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 60px;
}

.feature-card {
  flex: 0 0 calc(33.333% - 20px);
  background: #fff;
  border-radius: 10px;
  padding: 30px 25px;
  margin-bottom: 20px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.feature-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
}

.feature-card.featured {
  border-top: 3px solid #4a6bff;
}

.feature-card:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(74, 107, 255, 0.05), rgba(255, 255, 255, 0));
  z-index: 0;
}

.card-icon {
  font-size: 40px;
  margin-bottom: 20px;
  color: #4a6bff;
  position: relative;
  z-index: 1;
  display: inline-block;
}

.card-icon i {
  background: linear-gradient(135deg, #4a6bff, #2541b2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #1a1a2e;
  position: relative;
  z-index: 1;
}

.card-description {
  font-size: 15px;
  line-height: 1.6;
  color: #555;
  position: relative;
  z-index: 1;
}

.intro-content {
  max-width: 1000px;
  margin: 0 auto;
  padding: 30px 0;
}

.quote-container {
  position: relative;
  padding: 40px 30px;
  border-radius: 20px;
  background: linear-gradient(145deg, #ffffff, #f8f9ff);
  box-shadow: 0 15px 40px rgba(74, 107, 255, 0.08);
}

.quote-mark {
  font-size: 80px;
  line-height: 1;
  color: rgba(74, 107, 255, 0.15);
  font-family: Georgia, serif;
  position: absolute;
}

.quote-mark.start {
  top: 10px;
  left: 10px;
}

.quote-mark.end {
  bottom: 0;
  right: 20px;
}

.description-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 25px;
  position: relative;
  z-index: 2;
}

.description-item {
  padding: 20px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.7);
  transition: all 0.3s ease;
}

.description-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(74, 107, 255, 0.1);
}

.description-item.highlight {
  border-left: 3px solid #4a6bff;
}

.intro-paragraph {
  font-size: 1.1em;
  line-height: 1.7;
  color: #444;
  margin: 0;
  position: relative;
}

/* Icons */
.icon-enhance:before { content: '🔍'; }
.icon-color:before { content: '🎨'; }
.icon-repair:before { content: '🛠️'; }

@media (max-width: 992px) {
  .feature-card {
    flex: 0 0 calc(50% - 15px);
  }
  
  .description-grid {
    grid-template-columns: 1fr;
  }
  
  .quote-container {
    padding: 30px 20px;
  }
  
  .quote-mark {
    font-size: 60px;
  }
}

@media (max-width: 768px) {
  .product-intro {
    padding: 50px 0;
  }
  
  .section-title {
    font-size: 30px;
    margin-bottom: 40px;
  }
  
  .feature-card {
    flex: 0 0 100%;
  }
  
  .intro-paragraph {
    font-size: 1em;
    line-height: 1.6;
  }
  
  .quote-mark {
    font-size: 40px;
  }
  
  .quote-container {
    padding: 25px 15px;
  }
  
  .description-item {
    padding: 15px;
  }
}
</style> 